import script from "./rec-component-collection.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-component-collection.vue?vue&type=script&lang=ts&setup=true"

import "./rec-component-collection.vue?vue&type=style&index=0&id=6b70e8f3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b70e8f3"]])

export default __exports__